__turbopack_context__.v({
  "accordionSlideOverwrite": "label-module-scss-module__wjznzq__accordionSlideOverwrite",
  "fadeIn": "label-module-scss-module__wjznzq__fadeIn",
  "fadeOut": "label-module-scss-module__wjznzq__fadeOut",
  "label": "label-module-scss-module__wjznzq__label",
  "large": "label-module-scss-module__wjznzq__large",
  "medium": "label-module-scss-module__wjznzq__medium",
  "scaleIn": "label-module-scss-module__wjznzq__scaleIn",
  "scaleOut": "label-module-scss-module__wjznzq__scaleOut",
  "zoomIn": "label-module-scss-module__wjznzq__zoomIn",
  "zoomOut": "label-module-scss-module__wjznzq__zoomOut",
});
